import $ from "jquery";
import 'animate.css';

let elementOffset,
    scrollPosition,
    windowHeight,
    number;

if($('#js-scrollText').length){
  $(window).on('scroll', () => {
    elementOffset = $('#js-scrollText').offset().top;
    scrollPosition = $(window).scrollTop();
    windowHeight = $(window).height()
    if(scrollPosition > elementOffset - windowHeight + (windowHeight / 50) ){
      $('#js-scrollText').addClass('animate__animated animate__fadeInLeft');
    }
  });
}
